export const mutateUiAdminConfigKeys = {
  upsertUiAdminConfigEntry: ['upsertUiAdminConfigEntry'] as const
};
